import { useState, useCallback } from 'react';

export const useApiError = () => {
  const [error, setError] = useState(null);
  const [isRetrying, setIsRetrying] = useState(false);

  const handleError = useCallback((error) => {
    console.error('API Error:', error);
    setError(error);
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  const retry = useCallback(async (retryFunction) => {
    if (!retryFunction) return;

    setIsRetrying(true);
    try {
      await retryFunction();
      setError(null);
    } catch (err) {
      handleError(err);
    } finally {
      setIsRetrying(false);
    }
  }, [handleError]);

  return {
    error,
    isRetrying,
    handleError,
    clearError,
    retry
  };
};
